module.exports = __webpack_public_path__ + "static/media/E6.012f994.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/E6.mp4
// module id = Eyfr
// module chunks = 8